export type PickupType = "main" | "otopeni" | "custom";

export interface PickupPoint {
  id: Exclude<PickupType, "custom">;
  label: string;
  address: string;
  lat: number;
  lng: number;
}

export const DELIVERY_FEE = 20;

export const PICKUP_POINTS: PickupPoint[] = [
  {
    id: "main",
    label: "Our office — Bulevardul Regina Elisabeta 33",
    address: "Bulevardul Regina Elisabeta 33, Bucharest",
    lat: 44.4346358,
    lng: 26.0955811,
  },
  {
    id: "otopeni",
    label: "Henri Coandă Airport (Otopeni)",
    address: "Henri Coandă International Airport (OTP), Otopeni",
    lat: 44.5711,
    lng: 26.085,
  },
];

export const getPickupPoint = (id: Exclude<PickupType, "custom">) =>
  PICKUP_POINTS.find((p) => p.id === id)!;

export const mapEmbedUrl = (lat: number, lng: number, zoom = 15) =>
  `https://maps.google.com/maps?q=${lat},${lng}&z=${zoom}&hl=en&output=embed`;

export const googleMapsUrl = (lat: number, lng: number) =>
  `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;

export const wazeUrl = (lat: number, lng: number) =>
  `https://waze.com/ul?ll=${lat},${lng}&navigate=yes`;

/** Flat surcharge per airport transfer (pickup and/or drop-off at Otopeni). Currently 0 — no extra charge. */
export const AIRPORT_FEE = 0;

/** Meeting point instructions shown next to the Otopeni option. Placeholder — edit freely. */
export const OTOPENI_NOTE =
  "Our representative will meet you in the Arrivals terminal, near the short-term parking exit, holding a Carentals sign. Please add your flight number in the notes.";

export const locationLabel = (type: PickupType, customAddress: string) =>
  type === "custom"
    ? `Custom location — ${customAddress.trim() || "address to confirm"}`
    : getPickupPoint(type).address;
